import moment from 'moment';
moment.locale('en');

export const MONTHS = moment.months();
